import Api, { CleaningMission } from '@silbo/core';
import { CLEANING_MISSION_INCLUDES } from '../get-open-cleaning-missions/get-open-cleaning-missions-query';

export const getCleaningMissionQuery = (id: string) =>
  new Api.Query(CleaningMission).equalTo('objectId', id).include(CLEANING_MISSION_INCLUDES);
